








































































































































































































































































import { Component, Vue, Prop} from "vue-property-decorator";
import { Getter ,Action} from "vuex-class";
import getUrlParam from "@/common/utils/getUrlParam";
import getActivityType from '@/common/utils/getActivityType';
import getActivityDeadline from '@/common/utils/getActivityDeadline';
@Component({
  components: {
   
  }
})
export default class DistributeTabbar extends Vue {
    @Getter("section") section!: object;
    @Getter("distributeTypeParameter") distributeTypeParameter!: any;
    @Getter("uid") uid!: string;
  @Getter("hasPay") hasPay!: number;
  @Getter("cancel") cancel!: boolean;
    @Getter("startTime") startTime: any;
    @Getter("deadline") deadline!: number;
    @Getter("leftQuota") leftQuota!: string; //剩余课程数量
    @Getter("distributeOrderCreateTime") distributeOrderCreateTime!: number; //
    @Getter("myReward") myReward!: string;
    @Getter("distributeTradeId") distributeTradeId!: string;
    @Getter("nickname") nickname!: string;
  @Getter("avatar") avatar!: string;

  
    templateType: string = getActivityType() as string;
    type: string = getUrlParam("type") as string;
    broadcastId: string = (getUrlParam('broadcastId') as string);
    leftPayTimeStr:string = "";
    overTime:boolean = false;
    interval:any = {};
    statusInterval:any={};
    activityStatus:string="";
    deadlineDay:number = 0;
    submiting:boolean=false;
    mounted(){
      this.interval = setInterval(()=>{
        this.leftPayTime();
        const overTime = (Number(new Date()) - this.distributeOrderCreateTime > (15*60*1000));
        this.overTime = overTime;
      },1000)
      this.statusInterval = setInterval(()=>{
        this.getActivityStatus();
      },50)
    }
    getActivityStatus(){
      const activityDeadline: number = this.deadline;
      const activityStartTime: number = this.startTime;
      const nowTimestamp: number = new Date().valueOf();
      if(activityStartTime > nowTimestamp){
        this.activityStatus = "noStart";
      }else{
        if(nowTimestamp<activityDeadline){
          this.activityStatus = "startIng";
        }else{
          this.activityStatus = "endIng";
        }
      }
    }
    leftPayTime(){
      let endTime =  this.distributeOrderCreateTime + 15*60*1000;
      let leftMinute = getActivityDeadline(endTime).deadlineMinute;
      let leftSecond = getActivityDeadline(endTime).deadlineSecond;
      this.leftPayTimeStr =`${leftMinute}:${leftSecond}`;
    }
    toMyReward(){
      if (window.__wxjs_environment === 'miniprogram'){
        const distributorId = getUrlParam("distributorId");
        let shareFlag = 'YES';
        // 未报名，已支付/未支付且取消报名
        if (this.distributeTypeParameter.distributeMode === 'AFTER_BUY' && (this.cancel || !this.uid)) {
          shareFlag = 'NO';
        }
        const url = `/pages/my-reward/index?activityId=${this.broadcastId}&templateType=${this.templateType}&nickname=${this.nickname}&shareFlag=${shareFlag}&avatar=${this.avatar}`+ (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`) + (this.uid ? `&parentUid=${this.uid}` : `&parentUid=`);
        if(this.nickname) {
          window.wx.miniProgram.navigateTo({
            url: url
          });
        } else {
          Vue.$loading.show("正在加载..");
          setTimeout(() => {
            window.wx.miniProgram.navigateTo({
              url: url
            });
            Vue.$loading.hide();
          }, 3000);
        }
      }
    }
    toInvite(){
      if(this.activityStatus === 'noStart'){
         Vue.$toast.info("活动未开始");
      }else{
        console.log('nickname', this.nickname);
        if(this.nickname) {
          this.toMiniprogram();
        } else {
          Vue.$loading.show("正在加载..");
          setTimeout(() => {
            this.toMiniprogram();
            Vue.$loading.hide();
          }, 3000);
        }
      }
    }
    toMiniprogram() {
        const broadcastId = getUrlParam("broadcastId");
        const distributorId = getUrlParam("distributorId");
        const scene = `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}`+ (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`)+ (this.uid ? `&parentUid=${this.uid}` : `&parentUid=`);
        if (window.__wxjs_environment === 'miniprogram'){
          window.wx.miniProgram.navigateTo({
            url: `/pages/poster/index?${scene}`
          });
        }
    }
    toPayPage(){
      if (this.submiting) {
        Vue.$toast.error("请勿重复点击");
        return;
      }
      this.submiting = true;
      setTimeout(() => {
        this.submiting = false;
      }, 3000);
      const promoterId = getUrlParam("promoterId");
      const referralId = getUrlParam("referralId");
      const broadcastId = getUrlParam("broadcastId");
      const distributorId = getUrlParam("distributorId");
      const scene = `activityId=${broadcastId}&nickname=${this.nickname}&avatar=${this.avatar}` + (promoterId ? `&promoterId=${promoterId}` : "") +  (referralId ? `&referralId=${referralId}` : "") +  (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`);
      if (window.__wxjs_environment === 'miniprogram'){
        window.wx.miniProgram.navigateTo({
          url: `/pages/pay/index?${scene}`
        });
      }
    }
    toPayResultPage(){
      const broadcastId = getUrlParam("broadcastId");
      const distributorId = getUrlParam("distributorId");
      const scene = `activityId=${broadcastId}&userId=${this.uid}&nickname=${this.nickname}&avatar=${this.avatar}` + (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`);
      if (window.__wxjs_environment === 'miniprogram'){
        window.wx.miniProgram.navigateTo({
          url: `/pages/pay-result/index?${scene}`
        });
      }  
    }
    toBuy(){
      if(!this.uid){
        if(this.activityStatus === 'noStart'){
          Vue.$toast.info("活动未开始");
        }else{
         this.toPayPage();
        }
      }else{
        if(this.uid &&  this.hasPay !==4 && !this.overTime){
          this.toPayResultPage();
        }else{
          this.toPayPage();
        }
      }
    }
    toOrderDetail(){
      if (window.__wxjs_environment === 'miniprogram'){
        const broadcastId = getUrlParam("broadcastId");
        const scene = `tradeId=${this.distributeTradeId}`;
        let shareFlag = 'YES';
        // 未报名，已支付/未支付且取消报名
        if (this.distributeTypeParameter.distributeMode === 'AFTER_BUY' && (this.cancel || !this.uid)) {
          shareFlag = 'NO';
        }
        window.wx.miniProgram.navigateTo({
          url: `/pages/order-detail/index?${scene}&shareFlag=${shareFlag}`
        });
      }
    }
    destroyed(){
      clearInterval(this.interval)
    }

}
